import React from 'react';
import EduUserTemplate from 'components/branch/eduTemplate/EduUserTemplate';

function Eduuser() {
  return <EduUserTemplate />
}

export default Eduuser;
